export const RMA_KEYS = {
  ORDER_NO: { label: 'Order No', value: 'orderNo' },
  RMA_NO: { label: 'RMA No', value: 'rmaNo' },
  CREATED_BY: { label: 'Created By', value: 'createdBy' },
  PAYMENTS: { label: 'Payments', value: 'payments' },
  CREATED_AT: { label: 'Created At', value: 'createdAt' },
  IS_FULL_RMA: { label: 'Is Full RMA', value: 'isFullRMA' },
}
